// src/constants/categories.js
export const productCategories = [
  "Plants",
  "Summer Bulbs",
  "Winter Bulbs",
  "All-Season Bulbs",
  "Seeds",
  "Adeniums",
  "Rain-Lillies",
  "Others",
];

// For the filter on ProductListPage, we often want an "All" option
export const productCategoriesWithAll = ["All", ...productCategories];
